// extracted by css-extract-rspack-plugin
export default {"root":"root-2RSZC","month":"month-1Io8Z","calendar":"calendar-1R0zq","isWithinRange":"isWithinRange-kdeTT"};